import React, {useEffect} from "react";
import {Col} from "reactstrap";
import InputField from "../../inputs/InputField.tsx";
import {ErrorMessage} from "../../../../utils/ErrorMessage.tsx";
import {Controller} from "react-hook-form";
import Select from "react-select";
import {selectInputStyle} from "../../../../utils/SelectInputStyles.ts";
import TextareaField from "../../inputs/TextareaField.tsx";
import {GeneralDetailsFormComponentSchema} from "../../../../pages/VLoyalty/EditCampaign/EditCampaignSchema.ts";
import {LoyaltyGeneralDetailsContainer} from "./LoyaltyGeneralDetailsContainer.tsx";
import MandatoryField from "../../../../utils/MandatoryField.tsx";
import { MdCurrencyRupee } from "react-icons/md";
import {useSelector} from "react-redux";
import {customNumberInputHandler} from "../../../../utils/functions/customNumberInputHandler.ts";
import {VscPercentage} from "react-icons/vsc";
import {gstType} from "../Contact/FormComponentSchema.ts";

const LoyaltyGeneralDetailsFormComponent: React.FC<GeneralDetailsFormComponentSchema> = ({
isPercentage,
setIsPercentage,
campaignDetails,
register,
errors,
control,
watch,
setValue,
showDiscountField,
setShowDiscountField
}) => {

    const sessionScope = useSelector((state: any) => state.sessionData?.sessionScope);
    const decimalPoint = sessionScope?.decimalPoint || 2;
    const description = watch("description", "");

    useEffect(() => {
        if (watch("type")?.label === "Free Product" || (campaignDetails && campaignDetails?.campaign?.type === "Free Product")) {
            setShowDiscountField(false);
        }
    }, []);

    const campaignType:gstType [] = [
        { value: "Discount", label: "Discount" },
        { value: "Free Product", label: "Free Product"}
    ];


    return (
        <LoyaltyGeneralDetailsContainer>
            <>
                <div className="form-container">
                    <Col>
                        <InputField
                            labelName="Name"
                            placeholder="Name"
                            name="name"
                            id="name"
                            register={register}
                            errorMessage={ErrorMessage(errors?.name?.message)}
                            required
                        />
                    </Col>
                    <Col>
                        <InputField
                            labelName="Redemption Point"
                            placeholder="Redemption Point"
                            name="points"
                            id="points"
                            register={register}
                            errorMessage={ErrorMessage(errors?.points?.message)}
                            required
                            onKeyDown={customNumberInputHandler(10,decimalPoint)}
                        />
                    </Col>
                    <Col>
                        <label style={{fontWeight: 600}}>Type<MandatoryField/></label>
                        <Controller
                            name={"type"}
                            control={control}
                            render={({field}) => (
                                <Select
                                    placeholder={"Select Discount type"}
                                    styles={{
                                        ...selectInputStyle,
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            height: 33.8,
                                            minHeight: 33.8,
                                            minWidth: 200,
                                            width: "100%",
                                            maxWidth: "100%",
                                            borderColor: "#e3e3e3",
                                            borderBlockWidth: "1px",
                                            borderRightWidth: "1px",
                                            borderLeftWidth: "1px",
                                            borderWidth: "0px",
                                            outlineWidth: "0px",
                                            boxShadow: "none",
                                            borderRadius: "0.2rem",
                                            fontSize: "12px",
                                            marginBottom: "10px",
                                        }),
                                    }}
                                    options={campaignType}
                                    menuPortalTarget={document.body}
                                    {...field}
                                    onChange={(selectedOption) => {
                                        field.onChange(selectedOption);
                                        if (selectedOption?.label === "Free Product") {
                                            setShowDiscountField(false);
                                        } else {
                                            setShowDiscountField(true);
                                        }
                                    }}
                                    required
                                />
                            )}
                        />
                    </Col>

                    <Col>
                        {showDiscountField && <InputField
                            labelName="Discount Value"
                            name="discount"
                            placeholder="Enter discount"
                            showIcon={true}
                            inputIcon={isPercentage ? <VscPercentage /> : <MdCurrencyRupee />}
                            onIconClick={() => {
                                const discountValue = watch("discount"); // Get the current value
                                if (!isPercentage && parseFloat(discountValue) > 100) {
                                    setValue && setValue("discount", "100"); // Set to 100 if greater than 100
                                }
                                setIsPercentage && setIsPercentage(!isPercentage);
                            }}
                            register={register}
                            errorMessage={ErrorMessage(errors?.discount?.message)}
                            className={"input-field"}
                            required
                            onKeyDown={isPercentage ? customNumberInputHandler(3,decimalPoint,100): customNumberInputHandler(10,decimalPoint)}
                        />
                        }
                    </Col>
                </div>

                <div className="form-container ">
                    <Col>
                        <TextareaField
                            name="description"
                            id="description"
                            placeholder="Enter description"
                            register={register}
                            maxLength={200}
                            value={description}
                            onChange={(e) => setValue && setValue("description", e.target.value)}
                        />
                    </Col>
                </div>
            </>
        </LoyaltyGeneralDetailsContainer>
    );
};

export default LoyaltyGeneralDetailsFormComponent;
